import { isEmpty } from 'es-toolkit/compat';

import { Slide } from 'interfaces/slide';
import { MULTIPLEX_STAIN_ID } from 'interfaces/stainType';

export type MultiplexNormalizationCandidate = Pick<
  Slide,
  'stainingType' | 'channels' | 'channelMarkerTypes' | 'dnaChannelId'
> & {
  channelsMetadata?: unknown[] | Record<string, unknown> | null;
};

export const shouldLoadMultiplexNormalizations = (slide?: MultiplexNormalizationCandidate | null): boolean => {
  if (slide?.stainingType !== MULTIPLEX_STAIN_ID) {
    return false;
  }

  return (
    !isEmpty(slide.channels) ||
    !isEmpty(slide.channelMarkerTypes) ||
    !isEmpty(slide.channelsMetadata) ||
    (slide.dnaChannelId !== undefined && slide.dnaChannelId !== null && slide.dnaChannelId !== '')
  );
};
